import { createSubscriber, createConsumer, IEvent } from '@cian/events-log';
import { TDispatch, TApplicationState } from 'shared/types/redux';
import { setIsCianAuthorized } from 'shared/redux/userSlice';
import { setCianAuthorizedModalOpen } from 'shared/redux/landingSlice';
import { selectIsCianAuthorizedModalOpen, selectActionUrl } from 'shared/selectors/landing';

export function subscribeOnAuthentication(): (dispatch: TDispatch, getState: () => TApplicationState) => void {
  return (dispatch: TDispatch, getState: () => TApplicationState) => {
    if (typeof window === 'undefined') {
      return;
    }

    createConsumer({ topic: 'user' }).subscribe(
      createSubscriber((event: IEvent<unknown>) => {
        if (event.type === 'authenticated') {
          dispatch(setIsCianAuthorized(true));
          const state = getState();
          const actionUrl = selectActionUrl(state);
          if (selectIsCianAuthorizedModalOpen(state) && actionUrl) {
            window.open(actionUrl, '_self');
          }
        } else if (event.type === 'authentication_modal_closed') {
          dispatch(setCianAuthorizedModalOpen(false));
        }
      }),
    );
  };
}
